import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
} from "@mui/material";
import CustomTabs from "../components/common/CustomTabs";
import CustomInput from "./common/CustomInput";
import { useThemeContext } from "../context/ThemeContext";

const CustomModal = ({ 
  open, 
  onClose, 
  title, 
  initialData, 
  onSave, 
  fields = [], 
  tabLabels = [],
  customComponents = {}  
}) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === "dark";

  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState(initialData || {});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    onSave(formData);
    onClose();
  };

  // Tự động nhóm fields theo tab
  const groupedFields = {};
  fields.forEach(field => {
    const tab = field.tab || "Thông tin sản phẩm";
    if (!groupedFields[tab]) groupedFields[tab] = [];
    groupedFields[tab].push(field);
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          maxWidth: "1600px",
          maxHeight: "90vh",
          bgcolor: isDarkMode ? "#121212" : "white",
          color: isDarkMode ? "#000" : "#000",
          boxShadow: 10,
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>{title}</Typography>

        <CustomTabs activeTab={activeTab} setActiveTab={setActiveTab} tabLabels={Object.keys(groupedFields)} />

        {/* Nội dung modal theo tab */}
        <Box 
          sx={{ 
            flexGrow: 1, 
            overflowY: "auto", 
            p: 2, 
            maxHeight: "calc(90vh - 100px)",
          }}
        >
          <Grid container spacing={2}>
            {groupedFields[Object.keys(groupedFields)[activeTab]]?.map((field, index) => (
              <Grid item xs={field.fullWidth ? 12 : 4} key={index}>
                {customComponents[field.name] ? (
                  React.createElement(customComponents[field.name], {
                    label: field.label,
                    value: formData[field.name],
                    onChange: (newValue) => setFormData({ ...formData, [field.name]: newValue }),
                  })
                ) : (
                  <CustomInput label={field.label} name={field.name} value={formData[field.name]} onChange={handleChange} type={field.type} />
                )}
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Footer Buttons */}
        <Box sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          mt: 2, 
          borderTop: "1px solid #ddd", 
          pt: 1, 
          px: 1, 
          pb: 1,
        }}>
          <Button variant="contained" color="success" sx={{ width: "48%" }} onClick={handleSave}>
            Lưu
          </Button>
          <Button variant="outlined" color="error" sx={{ width: "48%" }} onClick={onClose}>
            Bỏ qua
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomModal;
